// Blog interactivity script
document.addEventListener('DOMContentLoaded', function() {
  // Get references to all relevant elements
  const heroSearchInput = document.querySelector('.blog-hero__search-input');
  const heroCategorySelect = document.querySelector('.blog-hero__categories-select');
  const browseAllLink = document.querySelector('.recent-posts__browse-all');
  const blogRecentSection = document.getElementById('shopify-section-blog-recent');
  const blogRecentPostsSection = document.getElementById('shopify-section-blog-recent-posts');
  const blogListSection = document.getElementById('shopify-section-blog-list');
  const blogPostCardSection = document.getElementById('shopify-section-blog-post-card');

  // Check if we're on a paginated URL (contains ?page=)
  const isPaginatedUrl = window.location.search.includes('page=');
  
  // Get saved filters from URL parameters 
  const urlParams = new URLSearchParams(window.location.search);
  const urlCategory = urlParams.get('category');
  const urlSearch = urlParams.get('search');
  
  console.log("URL parameters:", {
    category: urlCategory,
    search: urlSearch,
    isPaginatedUrl: isPaginatedUrl,
    showlisting: urlParams.get('showlisting')
  });
  
  // Set form fields based on URL parameters
  if (urlCategory && heroCategorySelect) {
    heroCategorySelect.value = urlCategory;
  }
  
  if (urlSearch && heroSearchInput) {
    heroSearchInput.value = urlSearch;
  }
  
  // Initially hide the blog listing section by default
  if (blogListSection) {
    // Show the blog listing section if we have filters or on a paginated page
    if (urlCategory || urlSearch || isPaginatedUrl || urlParams.has('showlisting') && urlParams.get('showlisting') === 'true') {
      console.log("Showing blog listing section due to filters/pagination");
      showBlogListing();
      
      // If we have category or search filters, immediately hide all posts and show loading
      if (urlCategory || urlSearch) {
        // First, immediately hide all posts to prevent flashing of unfiltered content
        const blogGrid = document.querySelector('.blog-listing__grid');
        if (blogGrid) {
          // Hide all existing posts immediately
          const existingPosts = blogGrid.querySelectorAll('.blog-card');
          existingPosts.forEach(post => {
            post.style.display = 'none';
          });
          
          // Create a loading indicator
          const loadingMessage = document.createElement('div');
          loadingMessage.className = 'blog-loading-message';
          loadingMessage.textContent = 'Loading all posts, please wait...';
          loadingMessage.style.cssText = 'width: 100%; text-align: center; padding: 50px 0; font-size: 1.2em; color: #666; grid-column: 1 / -1;';
          blogGrid.appendChild(loadingMessage);
          
          // Also hide pagination during loading
          const pagination = document.querySelector('.blog-listing__pagination');
          if (pagination) {
            pagination.style.display = 'none';
          }
        }
        
        // Load all blog posts, then apply filters
        loadAllBlogPosts().then(posts => {
          console.log("All posts loaded, applying filters");
          
          // Remove loading indicator
          const loadingMessage = document.querySelector('.blog-loading-message');
          if (loadingMessage) {
            loadingMessage.remove();
          }
          
          // Apply any filters from URL parameters
          if (urlCategory) {
            applyClientSideCategoryFilter(urlCategory, posts);
          }
          
          if (urlSearch) {
            applyClientSideSearchFilter(urlSearch, posts);
          }
        }).catch(error => {
          console.error("Error loading all posts:", error);
          
          // Update loading indicator to show error
          const loadingMessage = document.querySelector('.blog-loading-message');
          if (loadingMessage) {
            loadingMessage.textContent = 'Error loading posts. Please try again.';
          }
        });
      }
    } else {
      console.log("Hiding blog listing section - no filters/pagination");
      blogListSection.style.display = 'none';
    }
  }

  // Helper function to show blog listing and hide other content sections
  function showBlogListing() {
    console.log("Showing blog listing section");
    if (blogListSection) {
      blogListSection.style.display = 'block';
    }
    
    if (blogRecentSection) {
      blogRecentSection.style.display = 'none';
    }
    
    if (blogRecentPostsSection) {
      blogRecentPostsSection.style.display = 'none';
    }
    
    if (blogPostCardSection) {
      blogPostCardSection.style.display = 'none';
    }
  }
  
  // Function to load all blog posts by fetching each page
  async function loadAllBlogPosts() {
    console.log("Starting to load all blog posts for complete filtering");
    
    // Get the base blog URL without page parameter
    const baseUrl = window.location.pathname;
    
    // First, get the current page's posts and find total number of pages
    const blogGrid = document.querySelector('.blog-listing__grid');
    if (!blogGrid) {
      console.error("Blog grid not found");
      return [];
    }
    
    // Create array to store all posts
    let allPosts = [];
    
    // Extract posts from the current page first
    const currentPagePosts = blogGrid.querySelectorAll('.blog-card');
    console.log(`Found ${currentPagePosts.length} posts on current page`);
    
    // Add current page posts to our collection
    currentPagePosts.forEach(post => {
      allPosts.push(post.cloneNode(true));
    });
    
    // Find total number of pages
    const pagination = document.querySelector('.blog-listing__pagination');
    if (!pagination) {
      console.log("No pagination found, assuming single page");
      return allPosts;
    }
    
    const paginationItems = pagination.querySelectorAll('.blog-listing__pagination-item');
    let totalPages = 1;
    
    paginationItems.forEach(item => {
      const pageNum = parseInt(item.textContent);
      if (!isNaN(pageNum) && pageNum > totalPages) {
        totalPages = pageNum;
      }
    });
    
    console.log(`Found ${totalPages} total pages of posts`);
    
    // Get current page number
    const currentPage = parseInt(urlParams.get('page') || 1);
    console.log(`Current page: ${currentPage}`);
    
    // Fetch other pages - use Promise.all for parallel loading to improve speed
    const pagePromises = [];
    
    for (let page = 1; page <= totalPages; page++) {
      // Skip current page since we already have it
      if (page === currentPage) {
        continue;
      }
      
      console.log(`Preparing to fetch posts from page ${page}`);
      
      const pageUrl = new URL(baseUrl, window.location.origin);
      pageUrl.searchParams.set('page', page);
      
      // Create a promise for this page fetch
      const pagePromise = fetch(pageUrl.toString())
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const pagePosts = doc.querySelectorAll('.blog-card');
          console.log(`Loaded ${pagePosts.length} posts from page ${page}`);
          
          // Return the posts for this page
          return Array.from(pagePosts).map(post => post.cloneNode(true));
        })
        .catch(error => {
          console.error(`Error fetching page ${page}:`, error);
          return []; // Return empty array on error
        });
      
      pagePromises.push(pagePromise);
    }
    
    // Wait for all page fetches to complete
    const pageResults = await Promise.all(pagePromises);
    
    // Add all fetched posts to our collection
    pageResults.forEach(posts => {
      allPosts = allPosts.concat(posts);
    });
    
    console.log(`Total posts loaded: ${allPosts.length}`);
    return allPosts;
  }
  
  // Function to clear any previous filters and show all posts
  function clearAllFilters() {
    console.log("Clearing all filters");
    
    // Clear filter inputs
    if (heroCategorySelect) {
      heroCategorySelect.value = '';
    }
    
    if (heroSearchInput) {
      heroSearchInput.value = '';
    }
    
    // Navigate to the base URL without parameters
    const baseUrl = window.location.pathname;
    window.location.href = baseUrl;
  }
  
  // Helper function to handle pagination visibility
  function handlePaginationDisplay(visibleCount) {
    const pagination = document.querySelector('.blog-listing__pagination');
    const blogGrid = document.querySelector('.blog-listing__grid');
    
    if (pagination) {
      // Hide pagination if too few results
      if (visibleCount < 4) {
        pagination.style.display = 'none';
      } else {
        pagination.style.display = 'flex';
      }
      
      // Add a min-height to the grid if very few results to prevent layout shift
      if (visibleCount === 0) {
        if (blogGrid) {
          blogGrid.style.minHeight = '200px';
        }
        
        // Show a "no results" message
        let noResults = document.querySelector('.blog-listing__no-results');
        if (!noResults) {
          noResults = document.createElement('p');
          noResults.className = 'blog-listing__no-results';
          noResults.style.textAlign = 'center';
          noResults.style.width = '100%';
          noResults.style.padding = '40px 0';
          noResults.style.fontSize = '1.1em';
          noResults.style.color = '#666';
          blogGrid.appendChild(noResults);
        }
        noResults.textContent = 'No matching posts found. Please try a different search or category.';
        noResults.style.display = 'block';
      } else {
        // Hide no results message if it exists
        const noResults = document.querySelector('.blog-listing__no-results');
        if (noResults) {
          noResults.style.display = 'none';
        }
        
        if (blogGrid) {
          blogGrid.style.minHeight = '';
        }
      }
    }
  }
  
  // Function to apply category filter on all loaded posts
  function applyClientSideCategoryFilter(category, postsToUse = null) {
    console.log("Applying category filter for:", category);
    
    // Get the blog grid to display filtered results
    const blogGrid = document.querySelector('.blog-listing__grid');
    if (!blogGrid) {
      console.error("Blog grid not found");
      return;
    }
    
    // Clear the current grid content - this is crucial!
    blogGrid.innerHTML = '';
    
    // Use provided posts or try to fetch from DOM as fallback
    const posts = postsToUse || Array.from(document.querySelectorAll('.blog-card')).map(post => post.cloneNode(true));
    
    // Debug all category spans to see what we're working with
    console.log("All post categories:");
    posts.forEach((post, index) => {
      const categorySpan = post.querySelector('.blog-card__category');
      if (categorySpan) {
        console.log(`Post ${index}: "${categorySpan.textContent.trim()}"`);
      } else {
        console.log(`Post ${index}: No category found`);
      }
    });
    
    // Filter posts by category
    let visibleCount = 0;
    posts.forEach((post, index) => {
      const categorySpan = post.querySelector('.blog-card__category');
      let categoryFound = false;
      
      if (categorySpan) {
        const categoryText = categorySpan.textContent.trim();
        
        // Try different matching approaches
        if (
          categoryText === category || 
          categoryText.toLowerCase() === category.toLowerCase() ||
          categoryText.toLowerCase().includes(category.toLowerCase()) ||
          category.toLowerCase().includes(categoryText.toLowerCase())
        ) {
          categoryFound = true;
          console.log(`Match found for post ${index}: "${categoryText}" matches with "${category}"`);
        }
      }
      
      // If category matches, add to grid
      if (categoryFound) {
        blogGrid.appendChild(post);
        visibleCount++;
      }
    });
    
    console.log(`Found ${visibleCount} posts matching category "${category}"`);
    
    // Update heading
    const listingTitle = document.querySelector('.blog-listing__title');
    if (listingTitle) {
      listingTitle.textContent = `Category: ${category}`;
    }
    
    // Since we're filtering all posts, hide pagination - we're showing everything
    const pagination = document.querySelector('.blog-listing__pagination');
    if (pagination) {
      pagination.style.display = 'none';
    }
    
    // Show message if no results
    if (visibleCount === 0) {
      handlePaginationDisplay(0);
    }
  }
  
  // Function to apply search filter on all loaded posts
  function applyClientSideSearchFilter(searchTerm, postsToUse = null) {
    console.log("Applying search filter for:", searchTerm);
    
    // Get the blog grid to display filtered results
    const blogGrid = document.querySelector('.blog-listing__grid');
    if (!blogGrid) {
      console.error("Blog grid not found");
      return;
    }
    
    // Clear the current grid content - this is crucial!
    blogGrid.innerHTML = '';
    
    // Use provided posts or try to fetch from DOM as fallback
    const posts = postsToUse || Array.from(document.querySelectorAll('.blog-card')).map(post => post.cloneNode(true));
    
    // Get current category filter
    const urlParams = new URLSearchParams(window.location.search);
    const categoryFilter = urlParams.get('category');
    
    // Filter posts
    let visibleCount = 0;
    
    posts.forEach(post => {
      let shouldDisplay = true;
      
      // Apply category filter first if active
      if (categoryFilter) {
        shouldDisplay = false;
        
        const categorySpan = post.querySelector('.blog-card__category');
        if (categorySpan) {
          const categoryText = categorySpan.textContent.trim();
          
          // Try different matching approaches
          if (
            categoryText === categoryFilter || 
            categoryText.toLowerCase() === categoryFilter.toLowerCase() ||
            categoryText.toLowerCase().includes(categoryFilter.toLowerCase()) ||
            categoryFilter.toLowerCase().includes(categoryText.toLowerCase())
          ) {
            shouldDisplay = true;
          }
        }
      }
      
      // Then apply search filter
      if (shouldDisplay) {
        const title = post.querySelector('.blog-card__title')?.textContent.toLowerCase() || '';
        const excerpt = post.querySelector('.blog-card__excerpt')?.textContent.toLowerCase() || '';
        
        if (title.includes(searchTerm) || excerpt.includes(searchTerm)) {
          blogGrid.appendChild(post);
          visibleCount++;
        }
      }
    });
    
    console.log(`Found ${visibleCount} posts matching search "${searchTerm}"`);
    
    // Update heading
    const listingTitle = document.querySelector('.blog-listing__title');
    if (listingTitle) {
      if (categoryFilter) {
        listingTitle.textContent = `Category: ${categoryFilter} - Search: "${searchTerm}"`;
      } else {
        listingTitle.textContent = `Search results for: "${searchTerm}"`;
      }
    }
    
    // Since we're filtering all posts, hide pagination - we're showing everything
    const pagination = document.querySelector('.blog-listing__pagination');
    if (pagination) {
      pagination.style.display = 'none';
    }
    
    // Show message if no results
    if (visibleCount === 0) {
      handlePaginationDisplay(0);
    }
  }

  // Handle category selection
  if (heroCategorySelect) {
    console.log("Setting up category selection handler");
    
    // Log available options for debugging
    console.log("Available category options:");
    Array.from(heroCategorySelect.options).forEach(option => {
      console.log(`Option: "${option.value}" - Text: "${option.text}"`);
    });
    
    heroCategorySelect.addEventListener('change', function() {
      const selectedCategory = this.value;
      const selectedText = this.options[this.selectedIndex].text;
      console.log("Category selected:", selectedCategory, "Text:", selectedText);
      
      // Show all posts and reset messages when default option is selected
      if (!selectedCategory) {
        clearAllFilters();
        return;
      }
      
      // Build new URL with category parameter
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      
      // Update category parameter
      params.set('category', selectedCategory);
      
      // Remove page parameter to go back to page 1
      params.delete('page');
      
      // Remove search parameter if it exists
      params.delete('search');
      
      // Remove view parameter if it exists (to avoid conflicts with Shopify)
      params.delete('view');
      
      // Add showlisting=true parameter to show the blog listing section
      params.set('showlisting', 'true');
      
      // Update URL and navigate
      url.search = params.toString();
      window.location.href = url.toString();
    });
  } else {
    console.log("Category select element not found!");
  }

  // Handle search functionality
  if (heroSearchInput) {
    heroSearchInput.addEventListener('keyup', function(event) {
      // Process search when Enter key is pressed
      if (event.key === 'Enter') {
        const searchTerm = this.value.toLowerCase().trim();
        
        // If search is empty, clear filters and show all posts
        if (!searchTerm) {
          clearAllFilters();
          return;
        }
        
        // Build new URL with search parameter
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        
        // Update search parameter
        params.set('search', searchTerm);
        
        // Remove page parameter to go back to page 1
        params.delete('page');
        
        // Remove view parameter if it exists (to avoid conflicts with Shopify)
        params.delete('view');
        
        // Add showlisting=true parameter to show the blog listing section
        params.set('showlisting', 'true');
        
        // Update URL and navigate
        url.search = params.toString();
        window.location.href = url.toString();
      }
    });
  }

  // Handle "Browse All" link
  if (browseAllLink) {
    browseAllLink.addEventListener('click', function(event) {
      // Prevent the default link behavior
      event.preventDefault();
      
      // Navigate to the blog with showlisting=true parameter
      const url = new URL(window.location.pathname, window.location.origin);
      
      // Make sure to remove any view parameter
      url.searchParams.delete('view');
      
      url.searchParams.set('showlisting', 'true');
      window.location.href = url.toString();
    });
  }

  // Set up pagination handlers
  function setupPaginationHandlers() {
    const paginationLinks = document.querySelectorAll('.blog-listing__pagination a');
    paginationLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        
        // Get the pagination URL
        const paginationUrl = new URL(this.href);
        
        // Get current filter parameters
        const currentUrl = new URL(window.location.href);
        const currentParams = new URLSearchParams(currentUrl.search);
        
        // Preserve category parameter if it exists
        if (currentParams.has('category')) {
          paginationUrl.searchParams.set('category', currentParams.get('category'));
        }
        
        // Preserve search parameter if it exists
        if (currentParams.has('search')) {
          paginationUrl.searchParams.set('search', currentParams.get('search'));
        }
        
        // Remove view parameter if it exists (to avoid conflicts with Shopify)
        paginationUrl.searchParams.delete('view');
        
        // Always add showlisting=true parameter
        paginationUrl.searchParams.set('showlisting', 'true');
        
        // Navigate to the modified pagination URL
        window.location.href = paginationUrl.toString();
      });
    });
  }
  
  // Initialize pagination handlers
  setupPaginationHandlers();
});